var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-list-circle"},[_c('MoleculesCommonMoleculeListCircle',_vm._l((_vm.listCircleData),function(list,index){return _c('AtomsPortfolioAtomListCircle',{key:index,attrs:{"title":_vm.$tdb(list.title),"text":_vm.$tdb(list.text)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }